import { Locale } from 'date-fns';

export const getDateLocale = async (
  langCode: string | undefined,
): Promise<Locale> => {
  const lowerCaseLangCode = langCode?.toLowerCase();
  switch (lowerCaseLangCode) {
    case 'ar':
    case 'ar-ae':
    case 'ar-sa':
      return (await import('date-fns/locale/ar')).ar;

    case 'bg':
    case 'bg-bg':
      return (await import('date-fns/locale/bg')).bg;

    case 'cz':
    case 'cs':
    case 'cs-cz':
      return (await import('date-fns/locale/cs')).cs;

    case 'de':
    case 'de-de':
      return (await import('date-fns/locale/de')).de;

    case 'en-gb':
      return (await import('date-fns/locale/en-GB')).enGB;

    case 'es':
    case 'es-es':
      return (await import('date-fns/locale/es')).es;

    case 'fi':
    case 'fi-fi':
      return (await import('date-fns/locale/fi')).fi;

    case 'fr':
    case 'fr-fr':
    case 'fr-ca':
    case 'fr-ch':
      return (await import('date-fns/locale/fr')).fr;

    case 'id':
    case 'id-id':
      return (await import('date-fns/locale/id')).id;

    case 'it':
      return (await import('date-fns/locale/it')).it;

    case 'ja':
    case 'jp':
    case 'ja-jp':
      return (await import('date-fns/locale/ja')).ja;

    case 'ko':
    case 'kr':
    case 'ko-kr':
      return (await import('date-fns/locale/ko')).ko;

    case 'nl':
    case 'nl-nl':
      return (await import('date-fns/locale/nl')).nl;

    case 'pl':
    case 'pl-pl':
      return (await import('date-fns/locale/pl')).pl;

    case 'pt':
    case 'pt-pt':
    case 'pt-br':
      return (await import('date-fns/locale/pt')).pt;

    case 'ro':
    case 'ro-ro':
      return (await import('date-fns/locale/ro')).ro;

    case 'ru':
      return (await import('date-fns/locale/ru')).ru;

    case 'sv':
    case 'sv-se':
      return (await import('date-fns/locale/sv')).sv;

    case 'th':
    case 'th-th':
      return (await import('date-fns/locale/th')).th;

    case 'tr':
    case 'tr-tr':
      return (await import('date-fns/locale/tr')).tr;

    case 'vi':
    case 'vi-vn':
      return (await import('date-fns/locale/vi')).vi;

    case 'zh':
    case 'zh-cn':
    case 'zh-sg':
    case 'zh-hans':
      return (await import('date-fns/locale/zh-CN')).zhCN;

    case 'zh-hk':
    case 'zh-mo':
    case 'zh-hant':
    case 'zh-tw':
      return (await import('date-fns/locale/zh-TW')).zhTW;

    default:
      return (await import('date-fns/locale/en-US')).enUS;
  }
};
